import ElCheckboxButton from './CheckboxButton'

/* istanbul ignore next */
ElCheckboxButton.install = function (app) {
  app.component(ElCheckboxButton.name, ElCheckboxButton)
}

export default ElCheckboxButton
